<script>
import PurchaseHistory from "@/components/patientManagement/PurchaseHistory.vue";
import SinglePurchaseHistory from "@/components/patientManagement/SinglePurchaseHistory.vue";
import MyGames from "@/components/Agent/MyGames.vue";
import trainCalendar from "@/components/patientManagement/trainCalendar.vue";
import trainPlanPage from "@/components/patientManagement/trainPlanPage.vue";
import visionChallenge from "@/components/patientManagement/visionChallenge.vue";
import patientSystemLog from "@/components/patientManagement/patientSystemLog.vue";
import xiaomuzhineng from "@/components/patientManagement/xiaomuzhineng.vue";
import moment from "moment";
import {
  MapGender,
  calcTotalScore,
  MapEyeType,
  GetDoctorAdvice,
  MapVisionDisease,
  MapEeyVersion,
  MapTreatmentStage
} from "@/common/util";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
export default {
  components: {
    MyGames,
    PurchaseHistory,
    SinglePurchaseHistory,
    trainCalendar,
    trainPlanPage,
    visionChallenge,
    patientSystemLog,
    xiaomuzhineng
  },
  props: {
    type: {}
  },
  data() {
    const ROLE_GROUP_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_GROUP_OPTOMETRIST") > -1;
    const ROLE_AGENT_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1 ||
      localStorage.getItem("roles").indexOf("ROLE_STATION_MANAGER") > -1;
    const ROLE_DOCTOR =
      localStorage.getItem("roles").indexOf("ROLE_DOCTOR") > -1;
    const CanEdit =
      ROLE_DOCTOR || ROLE_AGENT_OPTOMETRIST || ROLE_GROUP_OPTOMETRIST;
    const stationId = this.$route.params.stationId;
    const patientId = this.$route.params.patientId;
    const tempSearch = sessionStorage.getItem("searchFormData")
      ? JSON.parse(sessionStorage.getItem("searchFormData"))
      : {};
    const start = moment()
      .subtract(6, "days")
      .format("YYYY-MM-DD");
    const end = moment().format("YYYY-MM-DD");
    const cache = sessionStorage.getItem("time");
    const value = cache
      ? cache.split(",")
      : tempSearch.dateRange
      ? tempSearch.dateRange
      : [start, end];
    let activeName = "训练方案";
    const isInitLabel = this.$cookie.get("tempTabLabel");
    if (isInitLabel === "患者病历") {
      activeName = "患者病历";
      this.$cookie.remove("tempTabLabel");
    }
    return {
      userInfo: {
        patientName: undefined,
        phone: undefined,
        gender: undefined,
        contactName: undefined,
        doctorName: undefined,
        location: undefined,
        birth: undefined,
        createdAt: undefined,
        configuration: {},
        fuseTrainType: undefined,
        expiredTime: undefined,
        expiredTimeFlag: undefined
      },
      patientTrainTrack: [],
      stationId,
      patientId,
      ROLE_AGENT_OPTOMETRIST,
      ROLE_GROUP_OPTOMETRIST,
      ROLE_DOCTOR,
      dateRange: value,
      tableData: [],
      editUser: false,
      singleGames: 0,
      editUserArray: [
        {
          label: "姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "性别",
          keyName: "gender",
          type: "radio",
          children: [
            {
              label: "男",
              keyName: "MALE"
            },
            {
              label: "女",
              keyName: "FEMALE"
            }
          ]
        },
        {
          label: "出生年月",
          keyName: "birth",
          type: "datePicker"
        },
        {
          label: "联系人",
          keyName: "contact",
          type: "text"
        },
        {
          label: "主治医生",
          keyName: "doctorName",
          type: "text"
        },
        {
          label: "患者类型",
          keyName: "visionDisease",
          type: "select",
          children: [
            {
              label: "弱视",
              keyName: "AMBLYOPIA"
            },
            {
              label: "斜视",
              keyName: "STRABISMUS"
            },
            {
              label: "其他",
              keyName: "OTHER"
            }
          ]
        },
        {
          label: "训练阶段",
          keyName: "treatmentStage",
          type: "select",
          children: [
            {
              label: "提升期",
              keyName: "PROMOTE"
            },
            {
              label: "巩固期",
              keyName: "CONSOLIDATION"
            }
          ]
        },
        {
          label: "手机号",
          keyName: "phone",
          type: "text"
        },
        {
          label: "联系地址",
          keyName: "contactLocation",
          type: "textarea"
        }
      ],
      options2: [
        {
          value: "0.01",
          label: "0.01(3.0)"
        },
        {
          value: "0.012",
          label: "0.012(3.1)"
        },
        {
          value: "0.015",
          label: "0.015(3.2)"
        },
        {
          value: "0.02",
          label: "0.02(3.3)"
        },
        {
          value: "0.025",
          label: "0.025(3.4)"
        },
        {
          value: "0.03",
          label: "0.03(3.5)"
        },
        {
          value: "0.04",
          label: "0.04(3.6)"
        },
        {
          value: "0.05",
          label: "0.05(3.7)"
        },
        {
          value: "0.06",
          label: "0.06(3.8)"
        },
        {
          value: "0.08",
          label: "0.08(3.9)"
        },
        {
          value: "0.1",
          label: "0.1(4.0)"
        },
        {
          value: "0.125",
          label: "0.125(4.1)"
        },
        {
          value: "0.15",
          label: "0.15(4.2)"
        },
        {
          value: "0.2",
          label: "0.2(4.3)"
        },
        {
          value: "0.25",
          label: "0.25(4.4)"
        },
        {
          value: "0.3",
          label: "0.3(4.5)"
        },
        {
          value: "0.4",
          label: "0.4(4.6)"
        },
        {
          value: "0.5",
          label: "0.5(4.7)"
        },
        {
          value: "0.6",
          label: "0.6(4.8)"
        },
        {
          value: "0.7",
          label: "0.7"
        },
        {
          value: "0.8",
          label: "0.8(4.9)"
        },
        {
          value: "0.9",
          label: "0.9"
        },
        {
          value: "1.0",
          label: "1.0(5.0)"
        },
        {
          value: "1.2",
          label: "1.2(5.1)"
        },
        {
          value: "1.5",
          label: "1.5(5.2)"
        },
        {
          value: "2.0",
          label: "2.0(5.3)"
        }
      ],
      myGames: [],
      patientPurchaseHistory: [],
      patientSinglePurchaseHistory: [],
      patientPurchaseHistorySource: {},
      patientSinglePurchaseHistorySource: {},
      // buttonArray: [
      //   {
      //     text: "修改方案",
      //     key: 0
      //   }
      // ],
      trainHistorList: [],
      trainHistorListSourceData: {},
      CanEdit,
      dialogTableVisible: false,
      marks: {
        50: {
          style: {
            color: "#00c1de"
          },
          label: this.$createElement("strong", "50%")
        }
      },
      adviceListForShow: [],
      adviceList: [],
      TempAdviceInput: "",
      TempSameVersion: 50,
      TempSameVersionBlue: "#003fff",
      TempSameVersionRed: "#ff0000",
      courseId: "",
      tempTrainHistorList: [],
      caseRecords: [],
      activeName,
      convergeCount: undefined,
      separateCount: undefined,
      fusionTrainingCount: undefined,
      centerDialogVisible: false,
      confirmContent: "",
      operationMedal: undefined,
      operationMedalStatus: undefined,
      fuseTrainType: undefined,
      leftEyeVision: undefined,
      rightEyeVision: undefined,
      loadTrainPlanCtrl: true,
      CourseData: {
        resetBegin: undefined,
        resetEnd: undefined,
        courseList: [],
        courseId: undefined
      },
      resetTreatment: false,
      trainingCourseId: undefined,
      expiredTimeDialogVisible: false,
      modelLevels: [
        {
          name: "刺激等级1",
          type: "1"
        },
        {
          name: "刺激等级2",
          type: "2"
        },
        {
          name: "刺激等级3",
          type: "3"
        },
        {
          name: "刺激等级4",
          type: "4"
        },
        {
          name: "刺激等级5",
          type: "5"
        },
        {
          name: "刺激等级6",
          type: "6"
        },
        {
          name: "刺激等级7",
          type: "7"
        },
        {
          name: "刺激等级8",
          type: "8"
        },
        {
          name: "刺激等级9",
          type: "9"
        },
        {
          name: "刺激等级10",
          type: "10"
        }
      ],
      removeCaserecordDialog: false,
      defaultValue: {}
    };
  },
  computed: {
    createdTime() {
      return `${moment(this.userInfo.createdAt).format("YYYY-MM-DD")}`;
    },
    expiredTime() {
      return `${moment(this.userInfo.expiredTime).format("YYYY-MM-DD")}`;
    },
    birthDay() {
      return `${
        this.userInfo.birth ? moment().diff(this.userInfo.birth, "years") : "--"
      }岁`;
    },
    DoctorAdvice() {
      // console.log(
      //   "GetDoctorAdvice(this.userInfo.label)",
      //   GetDoctorAdvice(this.userInfo.label)
      // );
      return GetDoctorAdvice(this.userInfo.label);
    },
    trainEyeSuggest() {
      if (
        this.rightEyeVision &&
        this.rightEyeVision.split("(")[0] &&
        this.leftEyeVision &&
        this.leftEyeVision.split("(")[0]
      ) {
        let rightEye = parseFloat(this.rightEyeVision.split("(")[0]);
        let leftEye = parseFloat(this.leftEyeVision.split("(")[0]);
        let MaxEye = rightEye > leftEye ? rightEye : leftEye;
        let MinEye = rightEye > leftEye ? leftEye : rightEye;
        let worse = rightEye < leftEye ? "RIGHT" : "LEFT";
        let avgEye = (rightEye + leftEye) / 2;

        if (this.userInfo.visionDisease === "STRABISMUS") {
          if (this.userInfo.label !== "BINOCULAR_SIMULTANEOUS") {
            return "建议训练眼别：双眼一起训练";
          } else {
            return "";
          }
        } else if (
          (MaxEye >= 0.9 && MinEye < 0.8) ||
          (MaxEye > 0.4 && MaxEye - MinEye > 0.2)
        ) {
          if (this.userInfo.label !== worse) {
            return `建议训练眼别：${worse === "RIGHT" ? "右眼" : "左眼"}训练`;
          } else {
            return "";
          }
        } else if (avgEye > 0.4) {
          if (this.userInfo.label !== "BINOCULAR_SIMULTANEOUS") {
            return "建议训练眼别：双眼一起训练";
          } else {
            return "";
          }
        } else if (avgEye <= 0.4) {
          if (this.userInfo.label !== "SEPARATION") {
            return "建议训练眼别：左右眼分开训练";
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    stimulusLevelSuggest() {
      if (
        this.rightEyeVision &&
        this.rightEyeVision.split("(")[0] &&
        this.leftEyeVision &&
        this.leftEyeVision.split("(")[0]
      ) {
        let rightEye = parseFloat(this.rightEyeVision.split("(")[0]);
        let leftEye = parseFloat(this.leftEyeVision.split("(")[0]);
        let MinEye = rightEye > leftEye ? leftEye : rightEye;
        let SuggestLevel = "";
        if (MinEye <= 0.1) {
          SuggestLevel = 1;
        } else if (MinEye <= 1) {
          SuggestLevel = Math.ceil(MinEye * 10);
        }
        if (MinEye > 1) {
          SuggestLevel = 10;
        }
        if (SuggestLevel) {
          return `建议刺激等级为：${SuggestLevel}`;
        }
        return "";
      }
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let data = await this.$http.DoctorGetPatientDetailByPatientId(
        this.patientId
      );
      if (data) {
        this.userInfo = cloneDeep(data);
        this.userInfo.gender = MapGender(data.gender);
        this.userInfo.visionDisease = data.visionDisease;
        this.userInfo.visionDiseaseType = MapVisionDisease(data.visionDisease);
        this.userInfo.eyeType = MapEyeType(data.label);
        this.userInfo.treatmentStage = data.treatmentStage;
        this.userInfo.treatmentStageType = MapTreatmentStage(
          data.treatmentStage
        );
        this.userInfo.fixationType = MapEyeType(data.fixation);
        this.userInfo.fixation = data.fixation;
        this.userInfo.eyeSameType = MapEyeType(data.configuration.label);
        this.userInfo.trainingEnabled = data.trainingEnabled;
        this.userInfo.valid = data.valid;
        this.userInfo.expiredTime = data.expiredTime;
        this.userInfo.expiredTimeFlag = data.expiredTime != null;
        this.tempUserInfo = cloneDeep(this.userInfo);
        this.leftEyeVision = MapEeyVersion(data.leftEyeVision);
        this.rightEyeVision = MapEeyVersion(data.rightEyeVision);
        this.adviceListForShow =
          data.advice && data.advice.length > 0 ? data.advice.split(";") : [];
        if (data.configuration.label !== "SIMULTANEOUS_PERCEPTION") {
          this.TempSameVersion = this.userInfo.configuration.advantageNumber;
          this.TempSameVersionBlue = this.userInfo.configuration.blue;
          this.TempSameVersionRed = this.userInfo.configuration.red;
        }
        if (data.convergeCount > 0 && data.separateCount > 0) {
          this.fuseTrainType = "other";
        } else if (data.convergeCount > 0 && data.separateCount < 1) {
          this.fuseTrainType = "converge";
        } else if (data.convergeCount < 1 && data.separateCount > 0) {
          this.fuseTrainType = "separate";
        }
        this.convergeCount = data.convergeCount;
        this.separateCount = data.separateCount;
        this.singleGames = data.singleGames;
        this.fusionTrainingCount =
          parseInt(data.convergeCount) + parseInt(data.separateCount);
        this.adviceList = this.adviceListForShow;
        sessionStorage.setItem("activePatientBirth", this.userInfo.birth);
      }
      if (this.activeName === "患者病历") {
        this.loadCaseRecords();
      }
    },
    async onEditAccount(form) {
      const updateData = {
        patientId: this.patientId,
        name: form.name,
        gender: form.gender,
        birth: moment(form.birth).format("YYYY-MM-DD"),
        contact: form.contact,
        doctorName: form.doctorName,
        phone: form.phone,
        contactLocation: form.contactLocation,
        visionDisease: form.visionDisease,
        treatmentStage: form.treatmentStage,
        stationId: this.stationId
      };
      const result = await this.$http.doctorEditPatient(updateData);
      if (result === "success") {
        this.$message.success("保存成功");
        this.loadData();
      }
    },
    onSwitch(tabs) {
      console.log("on switch")
      if (tabs.label === "训练方案") {
        // this.onLoadAgentRange();
      } else if (tabs.label === "患者病历") {
        this.loadCaseRecords();
      } else if (tabs.label === "训练打卡") {
        // this.onLoadAgentAccounts();
      } else if (tabs.label === "疗程购买历史") {
        this.loadPatientPurchaseHistory();
      } else if (tabs.label === "单次购买历史") {
        this.loadPatientSinglePurchaseHistory();
      } else if (tabs.label === "视力挑战") {
        //  this.loadPatientPurchaseHistory();
      } else if (tabs.label === "单次训练") {
        this.loadMyGames();
      }
    },
    handleCurrentChange(type, params) {
      if (type === "purchaseHistorList") {
        this.loadPatientPurchaseHistory(params);
      } else if (type === "singlePurchaseHistoryList") {
        console.log("hhhhhh")
        this.loadPatientSinglePurchaseHistory(params);
      } else if (type === "agentOrganization") {
        this.onLoadAgentStation(params);
      } else if (type === "agentAccountList") {
        this.onLoadAgentAccounts(params);
      }
    },
    // async loadMyGames() {
    //   console.log("load my games...")
    //   const result = await this.$http.getMyGames(
    //     {patientId: this.patientId}
    //   );
    //   this.myGames = result;
    // },
    async loadPatientSinglePurchaseHistory(params) {
      if (!params) {
        params = {}
      }
      params.size = 10
      params.sort = 'createdAt,DESC'
      params.patientId = this.patientId
      const result = await this.$http.getPatientSinglePurchaseHistory(params);
      if (result && result.content) {
        let newTableData = [];
        result.content.forEach(item => {
          newTableData.push({
            createdAt: moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss"),
            operatorName: item.doctorName,
            unitPrice: `¥${item.price * item.quantity}`,
            id: item.id,
            quantity: item.quantity,
            operateType: item.recordType === "PURCHASE" ? "购买" : "退款"
          });
        });
        this.patientSinglePurchaseHistory = newTableData;
        this.patientSinglePurchaseHistorySource = result;
      }
    },
    async loadPatientPurchaseHistory(params) {
      if (!params) {
        params = {}
      }
      params.size = 10
      params.sort = 'createdAt,DESC'
      const result = await this.$http.getPatientPurchaseHistory(
        this.patientId,
        params
      );
      if (result && result.content) {
        let newTableData = [];
        result.content.forEach(item => {
          newTableData.push({
            createdAt: moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss"),
            operatorName: item.operatorName,
            unitPrice: `¥${item.unitPrice * item.courseCount}`,
            id: item.id,
            courseCount: item.courseCount,
            operateType: item.operateType === "PAY" ? (item.complimentary ? "赠送" : "购买") : "退款"
          });
        });
        this.patientPurchaseHistory = newTableData;
        this.patientPurchaseHistorySource = result;
      }
    },
    onEditRemark() {
      this.loadData();
    },
    onClickFinishedTrain(row) {
      this.$router.push({
        path: `${this.$route.path}/finishedTrainDetail`
      });
    },
    onClickUnFinishedTrain(row) {
      this.$router.push({
        path: `${this.$route.path}/unplayTrainSet`
      });
    },
    onClickDeleteAdvice(index) {
      this.adviceList.splice(index, 1);
    },
    onClickDefaultAdvice(item2) {
      const advice = this.adviceList;
      advice.push(item2);
      this.adviceList = advice;
    },
    onClickDefaultAdviceAll(item) {
      const advice = this.adviceList;
      this.adviceList = advice.concat(item);
    },
    onClickSaveAdvice() {
      const advice = this.adviceList;
      if (this.TempAdviceInput === "" || this.TempAdviceInput.length < 5) {
        this.$message.warning("字数太少，请多输入一些");
      } else {
        advice.push(this.TempAdviceInput);
        this.adviceList = advice;
        this.TempAdviceInput = "";
      }
    },
    onTrainEyeChange(label) {
      if (
        this.userInfo.label === this.tempUserInfo.label &&
        this.userInfo.advice.length > 0
      ) {
        this.adviceList = this.userInfo.advice.split("#");
      } else {
        this.adviceList = [];
        this.TempAdviceInput = "";
      }
    },
    onSameVersionChange(label) {
      if (
        this.userInfo.configuration.label ===
        this.tempUserInfo.configuration.label
      ) {
        this.TempSameVersion = this.userInfo.configuration.advantageNumber;
        this.TempSameVersionBlue = this.userInfo.configuration.blue;
        this.TempSameVersionRed = this.userInfo.configuration.red;
      } else {
        if (this.userInfo.configuration.label === "AMBLYOPIA_DISINHIBITION") {
          this.TempSameVersion = 50;
          this.TempSameVersionBlue = `#003fff`;
          this.TempSameVersionRed = `#ff0000`;
        } else if (
          this.userInfo.configuration.label === "STRABISMUS_DISINHIBITION"
        ) {
          this.TempSameVersion = 100;
          this.TempSameVersionBlue = `#003fff`;
          this.TempSameVersionRed = `#ff0000`;
        }
      }
    },
    onSameVersionSliderValueChange(value) {
      const fillZero = item => {
        if (item == 0) {
          return "00";
        } else if (item < 16) {
          return `0${item.toString(16)}`;
        } else {
          return `${item.toString(16)}`;
        }
      };
      if (this.userInfo.configuration.label === "AMBLYOPIA_DISINHIBITION") {
        if (value > 50) {
          const red = Math.floor(255 * ((value - 50) / 50));
          const blue = Math.floor(255 - 255 * ((value - 50) / 50));
          const green = blue > 0 ? Math.floor(blue / 4) : 0;
          this.TempSameVersionBlue = `#${fillZero(red)}${fillZero(
            green
          )}${fillZero(blue)}`;
          this.TempSameVersionRed = `#ff0000`;
          const blueIcon = document.getElementById("TempSameVersionBlueIcon");
          const redIcon = document.getElementById("TempSameVersionRedIcon");
          blueIcon.style.color = `rgb(
            ${red},
            ${green},
            ${blue}
          )`;
          blueIcon.style.backgroundColor = `rgb(
            ${red},
            ${green},
            ${blue}
          )`;
          redIcon.style.color = `rgb(255,0,0)`;
          redIcon.style.backgroundColor = `rgb(255,0,0)`;
        } else if (value < 50) {
          const blue = Math.floor(255 * ((50 - value) / 50));
          const red = Math.floor(255 - 255 * ((50 - value) / 50));
          const green = blue > 0 ? Math.floor(blue / 4) : 0;
          this.TempSameVersionBlue = `#003fff`;
          this.TempSameVersionRed = `#${fillZero(red)}${fillZero(
            green
          )}${fillZero(blue)}`;
          const blueIcon = document.getElementById("TempSameVersionBlueIcon");
          const redIcon = document.getElementById("TempSameVersionRedIcon");
          redIcon.style.color = `rgb(
            ${red},
            ${green},
            ${blue}
          )`;
          redIcon.style.backgroundColor = `rgb(
            ${red},
            ${green},
            ${blue}
          )`;
          blueIcon.style.color = `rgb(0,64,255)`;
          blueIcon.style.backgroundColor = `rgb(0,64,255)`;
        } else {
          this.TempSameVersionBlue = `#003fff`;
          this.TempSameVersionRed = `#ff0000`;
          const blueIcon = document.getElementById("TempSameVersionBlueIcon");
          const redIcon = document.getElementById("TempSameVersionRedIcon");
          blueIcon.style.color = `rgb(0,64,255)`;
          blueIcon.style.backgroundColor = `rgb(0,64,255)`;
          redIcon.style.color = `rgb(255,0,0)`;
          redIcon.style.backgroundColor = `rgb(255,0,0)`;
        }
      } else if (
        this.userInfo.configuration.label === "STRABISMUS_DISINHIBITION"
      ) {
        const blue = Math.floor(155 + value);
        const red = Math.floor(155 + value);
        const green = blue > 0 ? Math.floor(blue / 4) : 0;
        this.TempSameVersionBlue = `#00${fillZero(green)}${fillZero(blue)}`;
        this.TempSameVersionRed = `#${fillZero(red)}0000`;
        const blueIcon = document.getElementById("TempSameVersionBlueIcon");
        const redIcon = document.getElementById("TempSameVersionRedIcon");
        blueIcon.style.color = `rgb(0,${green},${blue})`;
        blueIcon.style.backgroundColor = `rgb(0,${green},${blue})`;
        redIcon.style.color = `rgb(${red},0,0)`;
        redIcon.style.backgroundColor = `rgb(${red},0,0)`;
      }
    },
    async onSaveDoctorAdvince(NeedReset) {
      const configuration = {
        label: this.userInfo.configuration.label,
        advantageNumber:
          this.userInfo.configuration.label === "SIMULTANEOUS_PERCEPTION"
            ? ""
            : this.TempSameVersion,
        red:
          this.userInfo.configuration.label === "SIMULTANEOUS_PERCEPTION"
            ? ""
            : this.TempSameVersionRed,
        blue:
          this.userInfo.configuration.label === "SIMULTANEOUS_PERCEPTION"
            ? ""
            : this.TempSameVersionBlue
      };
      if (
        this.fuseTrainType === "other" &&
        (this.convergeCount === undefined ||
          this.separateCount === undefined ||
          this.convergeCount < 1 ||
          this.separateCount < 1)
      ) {
        this.$message.warning("保存失败，请稍后再试");
      } else {
        const updateData = {
          patientId: this.patientId,
          stationId: this.stationId,
          label: this.userInfo.label,
          fixation: this.userInfo.fixation,
          stimulusLevel: this.userInfo.stimulusLevel,
          advice: this.adviceList.join("#"),
          configuration,
          convergeCount: this.convergeCount,
          separateCount: this.separateCount,
          rightEyeVision: this.rightEyeVision
            ? this.rightEyeVision.split("(")[0]
            : null,
          leftEyeVision: this.leftEyeVision
            ? this.leftEyeVision.split("(")[0]
            : null
        };
        console.log()
        const result = await this.$http.setPatientTrainEyeConfig(updateData);
        if (result === "success") {
          if (NeedReset === "NeedReset") {
            if (this.CourseData.courseList.length > 0) {
              this.resetTreatment = true;
            } else {
              this.$message.warning("暂无可重置的训练方案！");
            }
          } else {
            this.$message.success("保存成功！");
          }
          this.loadData();
        } else {
          this.$message.warning("保存医嘱失败，请稍后再试");
          this.userInfo = cloneDeep(this.tempUserInfo);
        }
        this.dialogTableVisible = false;
      }
    },
    onConfigDialogClose() {
      // this.adviceList = [];
      // this.TempAdviceInput = "";
      // this.TempSameVersion = this.userInfo.configuration.advantageNumber;
      // this.TempSameVersionBlue = this.userInfo.configuration.blue;
      // this.TempSameVersionRed = this.userInfo.configuration.red;
      // this.userInfo = cloneDeep(this.tempUserInfo);
      this.loadData();
    },
    onClickCaseReocrd(row) {
      // console.log("row->>>>", row);
      if (row) {
        this.$router.push({
          path: `${this.$route.path}/caseRecord/${row.id}`
        });
      } else {
        this.$router.push({
          path: `${this.$route.path}/caseRecord/created`
        });
      }
    },
    async loadCaseRecords() {
      const caseRecords = await this.$http.getPatientCaseRecords(
        this.patientId
      );
      if (caseRecords && caseRecords.content) {
        this.caseRecords = caseRecords.content.map(item => {
          item.createdTime = moment(item.createdAt).format("YYYY-MM-DD HH:mm");
          item.OD_far_vision_with_glasses =
            item.result.OD_far_vision_with_glasses || "--";
          item.OS_far_vision_with_glasses =
            item.result.OS_far_vision_with_glasses || "--";
          item.OD_near_vision_with_glasses =
            item.result.OD_near_vision_with_glasses || "--";
          item.OS_near_vision_with_glasses =
            item.result.OS_near_vision_with_glasses || "--";
          return item;
        });
      }
    },
    valueChange(event, oldValue) {
      if (event && event.path && event.path[0] && event.path[0].value > 0) {
        if (oldValue === "convergeCount") {
          const temp = parseInt(this.separateCount) || 0;
          this.fusionTrainingCount = parseInt(event.path[0].value) + temp;
        } else if (oldValue === "separateCount") {
          const temp = parseInt(this.convergeCount) || 0;
          this.fusionTrainingCount = parseInt(event.path[0].value) + temp;
        }
      }
    },
    onFuseTrainTypeChange(label) {
      if (this.fuseTrainType === "converge") {
        this.convergeCount = 10;
        this.separateCount = 0;
      } else if (this.fuseTrainType === "separate") {
        this.convergeCount = 0;
        this.separateCount = 10;
      } else if (this.fuseTrainType === "other") {
        this.convergeCount = undefined;
        this.separateCount = undefined;
        this.fusionTrainingCount = undefined;
      }
    },
    onMedalChange(value, medal) {
      this.centerDialogVisible = true;
      this.operationMedal = medal;
      this.operationMedalStatus = value;
      this.confirmContent = `确认${value ? "授予" : "收回"}该勋章吗？`;
    },
    onClickCancel(key, isAfterSubmit) {
      this.centerDialogVisible = false;
      if (!isAfterSubmit) {
        if (this.operationMedal === "shilidaren") {
          this.userInfo.hasGotShilidaren = !this.operationMedalStatus;
        } else if (this.operationMedal === "shuangyanshigongnengdaren") {
          this.userInfo.hasGotShuangyanshigongnengdaren = !this
            .operationMedalStatus;
        } else if (this.operationMedal === "zhiyudaren") {
          this.userInfo.hasGotZhiyudaren = !this.operationMedalStatus;
        }
      }
      this.operationMedal = undefined;
      this.operationMedalStatus = undefined;
    },
    async onConfirmEdit() {
      const data = {
        medal: this.operationMedal
      };
      if (this.operationMedalStatus === false) {
        data.revoke = true;
      }
      const result = await this.$http.doctorUpdatePatientMedal(
        data,
        this.patientId
      );
      if (result) {
        this.$message.success("保存成功！");
        this.loadData();
      }
      this.centerDialogVisible = false;
      this.operationMedal = undefined;
      this.operationMedalStatus = undefined;
    },
    async resetPateintTreatment() {
      const patientId = this.patientId;
      let courseId = this.CourseData.courseId;
      if (courseId) {
        const result = await this.$http.doctorResetPatientPlan(
          courseId,
          patientId
        );
        if (result === "success") {
          this.$message.success("保存并重置操作成功！");
          this.loadData();
          this.loadTrainPlanCtrl = false;
          this.$nextTick(() => {
            this.loadTrainPlanCtrl = true;
          });
          this.resetTreatment = false;
        } else {
          this.$message.warning("重置操作失败！");
        }
      } else {
        this.$message.warning("疗程不存在！");
      }
    },
    saveCourseData(CourseData) {
      if (CourseData) {
        this.CourseData = CourseData;
        if (CourseData.courseList && CourseData.courseList[0]) {
          this.trainingCourseId = CourseData.courseList[0].id;
        }
      }
      const courseIdData = sessionStorage.getItem("courseId");
      let courseId = "";
      if (courseIdData) {
        const data = JSON.parse(courseIdData);
        if (data.patientId === this.patientId) {
          courseId = data.courseId;
        }
      }
      this.courseId = courseId;
    },
    onResetCourseClose() {
      console.log('>>>>', this.CourseData)
      // this.CourseData.courseId = this.trainingCourseId;
    },
    async onSetPatientTrainEnable(value) {
      const data = {
        enabled: value
      };
      const result = await this.$http.setPatientTrainEnabled(
        this.patientId,
        data
      );
      if (result) {
        this.$message.success("操作成功！");
      }
    },
    async onSetPatientTrainValid(value) {
      const data = {
        enabled: value
      };
      const result = await this.$http.setPatientTrainValid(
        this.patientId,
        data
      );
      if (result) {
        this.$message.success("操作成功！");
      }
    },
    handleClickExpiredTime() {
      this.expiredTimeDialogVisible = true;
    },
    async onSetTrainingTimeout(val) {
      if (!this.CourseData.courseList || this.CourseData.courseList.length === 0) {
        this.$message.warning("设置限时前，请先定制疗程");
        this.loadData();
        return;
      }
      if (val) {
        this.expiredTimeDialogVisible = true;
      } else {
        const data = {expiredFlag: val, patientId: this.patientId}
        const result = await this.$http.updatePatientExpiredDate(data)
        if (result) {
          this.$message.success("操作成功！");
          this.loadData();
        }
      }
    },
    async confirmSetExpiredTime() {
      if (!this.expiredTime) {
        this.$message.warning("请选择截止日期");
        return;
      }
      const data = {
        expiredFlag: true,
        expiredTime: this.expiredTime,
        patientId: this.patientId
      }
      const result = await this.$http.updatePatientExpiredDate(data)
      if (result) {
        this.$message.success("操作成功！");
        this.expiredTimeDialogVisible = false;
        this.loadData();
      }
    },
    onCancelExpiredTime() {
      this.expiredTimeDialogVisible = false;
      this.loadData();
    },
    openInNewWindow(row) {
      let routeData = this.$router.resolve({
        name: "caseRecordPreview",
        path: `${this.$route.path}/caseRecord/${row.id}`
      });
      window.open(routeData.href, "_blank");
    },
    async removeCaserecord(row) {
      console.log("-removeCaserecord", row);
    },
    onCancelRemoveCaserecord() {
      this.removeCaserecordDialog = false;
      this.defaultValue = {};
    },
    async confirmRemoveCaserecord() {
      console.log("this.defaultValue", this.defaultValue);
      const result = await this.$http.removeCaseRecords(this.defaultValue.id);
      if (result) {
        this.loadCaseRecords();
      }
      this.onCancelRemoveCaserecord();
    },
    onClickRemove(row) {
      this.defaultValue = row;
      this.removeCaserecordDialog = true;
    },
    singleGamesChange(val) {
      console.log("singleGamesChange:" + val)
      this.singleGames = val
    }
  }
};
</script>
<template>
  <div class="trainDetailIndex">
    <el-dialog
      title="训练配置"
      width="1080px"
      class="configDialog"
      center
      :visible.sync="dialogTableVisible"
      @close="onConfigDialogClose"
    >
      <el-row :gutter="24">
        <el-col :span="3">
          <div class="item">同时视配置：</div>
        </el-col>
        <el-col :span="21" class="contentCol">
          <el-radio-group v-model="userInfo.configuration.label" @change="onSameVersionChange">
            <el-radio label="SIMULTANEOUS_PERCEPTION">同时视</el-radio>
            <el-radio label="AMBLYOPIA_DISINHIBITION">弱视脱抑制</el-radio>
            <el-radio label="STRABISMUS_DISINHIBITION">斜视脱抑制</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row
        :gutter="24"
        class="smaeVersionConfigRow"
        v-if="userInfo.configuration.label && userInfo.configuration.label !== 'SIMULTANEOUS_PERCEPTION'"
      >
        <el-col :span="3"></el-col>
        <el-col
          :span="2"
          style="padding-top: 5px"
          v-if="userInfo.configuration.label === 'AMBLYOPIA_DISINHIBITION'"
          class="contentCol"
        >
          <div class="item">左眼优势</div>
        </el-col>
        <el-col
          :span="2"
          style="padding: 0; padding-top: 5px"
          v-if="userInfo.configuration.label === 'STRABISMUS_DISINHIBITION'"
          class="contentCol"
        >
          <div class="item">同时视能力</div>
        </el-col>
        <el-col :span="6" class="contentCol">
          <div class="block">
            <el-slider
              :min="0"
              :max="100"
              :marks="userInfo.configuration.label === 'AMBLYOPIA_DISINHIBITION' ? marks : null"
              @change="onSameVersionSliderValueChange"
              v-model="TempSameVersion"
            ></el-slider>
          </div>
        </el-col>
        <el-col :span="2" style="padding: 5px" class="contentCol">
          <div class="item" v-if="userInfo.configuration.label === 'AMBLYOPIA_DISINHIBITION'">右眼优势</div>
        </el-col>
        <el-col :span="1" class="contentCol">
          <div class="item">红：</div>
        </el-col>
        <el-col :span="3" class="contentCol">
          <el-input v-model="TempSameVersionRed" :disabled="true" size="small">
            <i
              slot="suffix"
              class="el-input__icon el-icon-picture"
              id="TempSameVersionRedIcon"
              :style="{'color': TempSameVersionRed,'background-color': TempSameVersionRed,'border': '1px #666666 solid', 'line-height':'25px', 'height': '25px','margin':'2px 0'}"
            ></i>
          </el-input>
        </el-col>
        <el-col :span="1" class="contentCol">
          <div class="item">蓝：</div>
        </el-col>
        <el-col :span="3" class="contentCol">
          <el-input v-model="TempSameVersionBlue" :disabled="true" size="small">
            <i
              slot="suffix"
              class="el-input__icon el-icon-picture"
              id="TempSameVersionBlueIcon"
              :style="{'color': TempSameVersionBlue, 'background-color':TempSameVersionBlue,'border': '1px #666666 solid', 'line-height':'25px', 'height': '25px','margin':'2px 0'}"
            ></i>
          </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="3">
          <div class="item">融合视配置：</div>
        </el-col>
        <el-col :span="21" class="contentCol">
          <el-radio-group v-model="fuseTrainType" @change="onFuseTrainTypeChange">
            <el-radio label="converge">辐辏</el-radio>
            <el-radio label="separate">分开</el-radio>
            <el-radio label="other">比例</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="fuseTrainType === 'other'" class="smaeVersionConfigRow">
        <el-col :span="3">
          <div class="item"></div>
        </el-col>
        <el-col :span="21" class="contentCol">
          <div class="cellItem">辐辏：</div>
          <el-input-number
            class="cellItemInput"
            @input.native="(event) => valueChange(event,'convergeCount')"
            :controls="false"
            :step-strictly="true"
            v-model="convergeCount"
            :min="1"
            size="small"
          ></el-input-number>
          <div class="cellItem">分开：</div>
          <el-input-number
            class="cellItemInput"
            @input.native="(event) => valueChange(event,'separateCount')"
            :controls="false"
            :step-strictly="true"
            v-model="separateCount"
            :min="1"
            size="small"
          ></el-input-number>
          <div class="cellItem">训练次数：</div>
          <el-input-number
            class="cellItemInput"
            :controls="false"
            v-model="fusionTrainingCount"
            :disabled="true"
            size="small"
          ></el-input-number>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="3">
          <div class="item">矫正视力：</div>
        </el-col>
        <el-col :span="4" class="contentCol">
          右眼：
          <el-select v-model="rightEyeVision" class="eyeDegreeSelect" size="mini" placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" class="contentCol">
          左眼：
          <el-select v-model="leftEyeVision" class="eyeDegreeSelect" size="mini" placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="3">
          <div class="item">刺激等级：</div>
        </el-col>
        <el-col :span="21" class="contentCol">
          <el-select size="mini" v-model="userInfo.stimulusLevel" class="selectInputStyle">
            <el-option
              v-for="(model, index) in modelLevels"
              :key="index + '_modelLevel'"
              :label="model.name"
              :value="model.type"
            />
          </el-select>
          <span v-if="stimulusLevelSuggest" class="trainEyeSuggest">
            <i class="el-icon-warning" />
            {{stimulusLevelSuggest}}
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="3">
          <div class="item">注视方式：</div>
        </el-col>
        <el-col :span="21" class="contentCol">
          <el-radio-group v-model="userInfo.fixation">
            <el-radio label="CENTRAL_FIXATION">中心注视</el-radio>
            <el-radio label="EC_CENTRAL_FIXATION">旁中心注视</el-radio>
            <el-radio label="NYSTAGMUS">眼球震颤</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="3">
          <div class="item">训练眼别：</div>
        </el-col>
        <el-col :span="21" class="contentCol">
          <el-radio-group v-model="userInfo.label" @change="onTrainEyeChange">
            <el-radio label="RIGHT">右眼</el-radio>
            <el-radio label="LEFT">左眼</el-radio>
            <el-radio label="BINOCULAR_SIMULTANEOUS">双眼同时</el-radio>
            <el-radio label="SEPARATION">左右眼分开</el-radio>
          </el-radio-group>
          <span v-if="trainEyeSuggest" class="trainEyeSuggest">
            <i class="el-icon-warning" />
            {{trainEyeSuggest}}
          </span>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="3">
          <div class="item">修改医嘱：</div>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col
          :span="11"
          class="doctorAdviceCol"
          v-for="(item, index) in DoctorAdvice"
          :key="item.type + index"
        >
          <el-row :gutter="24">
            <el-col :span="24">
              <div @click="onClickDefaultAdviceAll(item.list)" class="doctorAdvice">
                <i class="el-icon-circle-plus" :style="{'color': 'gray'}"></i>
                添加全部（{{item.type}}）
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-for="(item2,index2) in item.list" :key="item2[0] + index2">
            <el-col :span="24">
              <div @click="onClickDefaultAdvice(item2)" class="doctorAdvice">{{item2}}</div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="11" class="doctorAdviceContent doctorAdviceCol">
          <el-row :gutter="24" v-for="(item2,index2) in adviceList" :key="item2[0] + index2">
            <el-col :span="24">
              <span class="doctorAdvice">{{item2}}</span>
              <el-button
                type="text"
                icon="el-icon-minus"
                :style="{'height': '22px'}"
                circle
                @click="onClickDeleteAdvice(index2)"
              ></el-button>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-input
                class="doctorAdviceInput"
                placeholder="自定义医嘱"
                size="small"
                v-model="TempAdviceInput"
                clearable
              ></el-input>
              <el-button type="text" icon="el-icon-plus" circle @click="onClickSaveAdvice"></el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialogConfirmButton" @click="onSaveDoctorAdvince()">保 存</el-button>
        <el-button
          class="dialogConfirmWithResetButton"
          @click="onSaveDoctorAdvince('NeedReset')"
          size="medium"
          type="primary"
        >保存并重置训练方案</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="resetPlanDialog"
      title
      :visible.sync="resetTreatment"
      width="446px"
      center
      @close="onResetCourseClose"
    >
      <div class="resetContent">
        <div class="resetText">
          <div>将根据患者当前视力特点重置本疗程未训练项目，</div>
          <div>部分训练游戏的起始关卡可能发生改变</div>
        </div>
        <div
          class="line"
          v-if="CourseData.courseList.length > 1 && CourseData.resetEnd - CourseData.resetBegin < 14"
        ></div>
        <span
          v-if="CourseData.courseList.length > 1 && CourseData.resetEnd - CourseData.resetBegin < 14"
        >
          疗程选择：
          <el-select class="courseSelect" v-model="CourseData.courseId" placeholder="请选择">
            <el-option
              v-for="item in CourseData.courseList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </span>
        <div class="line"></div>
        <span
          class="levelItem"
          v-if="CourseData.courseId === trainingCourseId && CourseData.resetEnd - CourseData.resetBegin > 1 && CourseData.resetBegin < CourseData.resetEnd"
        >
          重置第
          <el-input-number
            :controls="false"
            size="small"
            class="ctrlNumberInput"
            v-model="CourseData.resetBegin"
            :disabled="true"
          />次至第
          <el-input-number
            :controls="false"
            size="small"
            class="ctrlNumberInput"
            v-model="CourseData.resetEnd"
            :disabled="true"
          />次的训练
        </span>
        <span class="levelItem" v-else-if="CourseData.courseId !==  trainingCourseId">重置该疗程的全部训练</span>
        <span
          class="levelItem"
          v-if="CourseData.courseId ===  trainingCourseId && !(CourseData.resetEnd - CourseData.resetBegin > 1 && CourseData.resetBegin < CourseData.resetEnd)"
        >
          <el-alert
            class="noticeItem"
            title="该疗程剩余训练小于1次，请选择其他疗程"
            type="warning"
            show-icon
            :closable="false"
          ></el-alert>
        </span>
        <span
          class="levelItem"
          v-else-if="CourseData.courseList.length === 1 && !(CourseData.resetEnd - CourseData.resetBegin > 1 && CourseData.resetBegin < CourseData.resetEnd)"
        >
          <el-alert
            class="noticeItem"
            title="该患者暂无可以重置的疗程"
            type="warning"
            show-icon
            :closable="false"
          ></el-alert>
        </span>
        <el-alert
          class="noticeItem"
          v-if="CourseData.courseId !==  trainingCourseId || (CourseData.resetEnd - CourseData.resetBegin > 1 && CourseData.resetBegin < CourseData.resetEnd)"
          title="必须保证患者视功能特性填写完整。"
          type="warning"
          show-icon
          :closable="false"
        ></el-alert>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :disabled="!(CourseData.courseId !==  trainingCourseId || (CourseData.resetEnd - CourseData.resetBegin > 1 && CourseData.resetBegin < CourseData.resetEnd))"
          class="dialogConfirmButton"
          @click="resetPateintTreatment"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="设置限时截止日期"
      :visible.sync="expiredTimeDialogVisible"
      width="400px"
      center
    >
      <div class="expiredTimeContent">
        <el-date-picker
          v-model="userInfo.expiredTime"
          type="date"
          placeholder="选择截止日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        ></el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialogConfirmButton" @click="confirmSetExpiredTime()">确 定</el-button>
        <el-button class="dialogCancelButton" @click="onCancelExpiredTime()">取 消</el-button>
      </span>
    </el-dialog>
    <el-alert
      v-if="userInfo.stimulusLevel === null"
      type="error"
      title="该患者尚未配置刺激等级！"
      :closable="false"
      center
      class="forgetStimulusLevelAlert"
    />
    <el-card class="box-card cardStyle" shadow="never">
      <div class="text">
        <div class="headerText item">
          {{userInfo.name}}
          <img alt="女"
            v-if="userInfo.gender === '女'"
            class="genderStyle"
            src="@/assets/female.png"
          />
          <img alt="男" v-if="userInfo.gender === '男'" class="genderStyle" src="@/assets/male.png" />
          <span class="item">{{birthDay}}</span>
          <DialogForm
            v-if="editUser"
            :defaultValue="userInfo"
            formTitle="编辑"
            :formInputArray="editUserArray"
            @close="editUser = false"
            @submitForm="onEditAccount"
          />
        </div>
        <el-row :gutter="24">
          <el-col :span="11">
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  <span class="leftTitle">联系人：</span>
                  <span class="detailText">{{userInfo.contact}}</span>
                  <i class="el-icon-edit editIcon" v-if="CanEdit" @click="editUser = true">
                    <span>编辑</span>
                  </i>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  <span class="leftTitle">联系地址：</span>
                  <span class="detailText">{{userInfo.contactLocation}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  <span class="leftTitle">主治医生：</span>
                  <span class="detailText">{{userInfo.doctorName}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  <span class="leftTitle">备注：</span>
                  <span class="detailText">{{userInfo.remark}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  <span class="leftTitle">创建时间：</span>
                  <span class="detailText">{{createdTime}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  <span class="leftTitle">电话号：</span>
                  <span class="detailText">{{userInfo.phone}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  <span class="leftTitle">患者类型：</span>
                  <span class="detailText">{{userInfo.visionDiseaseType}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  <span class="leftTitle">训练阶段：</span>
                  <span class="detailText">{{userInfo.treatmentStageType}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  视力达人勋章：
                  <span class="medalContent">
                    <el-switch
                      :disabled="!CanEdit"
                      v-model="userInfo.hasGotShilidaren"
                      active-color="#00c1de"
                      inactive-color="#E6E6E6"
                      @change="value => onMedalChange(value, 'shilidaren')"
                    ></el-switch>
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  双眼视功能达人勋章：
                  <span class="medalContent">
                    <el-switch
                      :disabled="!CanEdit"
                      v-model="userInfo.hasGotShuangyanshigongnengdaren"
                      active-color="#00c1de"
                      inactive-color="#E6E6E6"
                      @change="value => onMedalChange(value, 'shuangyanshigongnengdaren')"
                    ></el-switch>
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  治愈达人勋章：
                  <span class="medalContent">
                    <el-switch
                      :disabled="!CanEdit"
                      v-model="userInfo.hasGotZhiyudaren"
                      active-color="#00c1de"
                      inactive-color="#E6E6E6"
                      @change="value => onMedalChange(value, 'zhiyudaren')"
                    ></el-switch>
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  训练状态：
                  <span class="medalContent">
                    <el-switch
                      v-model="userInfo.trainingEnabled"
                      active-color="#00c1de"
                      inactive-color="red"
                      @change="value => onSetPatientTrainEnable(value)"
                    ></el-switch>
                    {{!userInfo.trainingEnabled ? '(已停止训练)' : '(已开启)'}}
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  是否计入AI训练：
                  <span class="medalContent">
                    <el-switch
                      :disabled="!(ROLE_GROUP_OPTOMETRIST)"
                      v-model="userInfo.valid"
                      active-color="#00c1de"
                      inactive-color="red"
                      @change="value => onSetPatientTrainValid(value)"
                    ></el-switch>
                    {{!userInfo.valid ? '(已停止计入AI)' : '(计入AI)'}}
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="item">
                  <span class="leftTitle">训练限时：</span>
                  <span class="medalContent">
                    <el-switch
                      v-model="userInfo.expiredTimeFlag"
                      active-color="#00c1de"
                      inactive-color="red"
                      @change="value => onSetTrainingTimeout(value)"
                    ></el-switch>
                    {{userInfo.expiredTimeFlag ? '己限时' : '未限时'}}
                  </span>
                  <a href="javascript:void(0);" v-if="userInfo.expiredTimeFlag" @click="handleClickExpiredTime">({{expiredTime}})</a>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="13">
            <el-row :gutter="24">
              <el-col :span="20">
                <span class="leftTitle">限时截止日期：</span>
                <span class="detailText">{{expiredTime ? expiredTime : '未设置'}}</span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- <el-col :span="5">
                <div class="item">同时视配置：</div>
              </el-col>-->
              <el-col :span="20">
                <span class="leftTitle">同时视配置：</span>
                <span class="detailText">{{userInfo.eyeSameType}}</span>
                <i class="el-icon-edit editIcon" v-if="CanEdit" @click="dialogTableVisible = true">
                  <span>编辑</span>
                </i>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- <el-col :span="5">
                <div class="item">融合视配置：</div>
              </el-col>-->
              <el-col :span="20">
                <span class="leftTitle">融合视配置：</span>
                <span
                  v-if="userInfo.convergeCount > 0 && userInfo.separateCount < 1"
                  class="detailText"
                >辐辏</span>
                <span
                  v-else-if="userInfo.convergeCount < 1 && userInfo.separateCount > 0"
                  class="detailText"
                >分开</span>
                <span
                  v-else-if="userInfo.convergeCount > 0 && userInfo.separateCount > 0"
                  class="detailText"
                >比例</span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- <el-col :span="5">
                <div class="item">矫正视力：</div>
              </el-col>-->
              <el-col :span="11">
                <span class="leftTitle">矫正视力：</span>
                <span class="detailText">右眼：{{rightEyeVision}}</span>
              </el-col>
              <el-col :span="6">
                <span class="detailText">左眼：{{leftEyeVision}}</span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- <el-col :span="5">
                <div class="item">刺激等级：</div>
              </el-col>-->
              <el-col :span="20">
                <span class="leftTitle">刺激等级：</span>
                <span class="detailText">{{userInfo.stimulusLevel}}</span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- <el-col :span="5">
                <div class="item">注视方式：</div>
              </el-col>-->
              <el-col :span="20">
                <span class="leftTitle">注视方式：</span>
                <span class="detailText">{{userInfo.fixationType}}</span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- <el-col :span="5">
                <div class="item">训练眼别：</div>
              </el-col>-->
              <el-col :span="20">
                <span class="leftTitle">训练眼别：</span>
                <span class="detailText">{{userInfo.eyeType}}</span>
              </el-col>
            </el-row>
            <el-row :gutter="24" v-if="adviceListForShow.length === 0">
              <!-- <el-col :span="5">
                <div class="item">医嘱：</div>
              </el-col>-->
              <el-col :span="20">
                <span class="leftTitle">医嘱：</span>
                <span class="detailText"></span>
              </el-col>
            </el-row>
            <el-row :gutter="24" v-for="(item, index) in adviceListForShow" :key="item + index">
              <!-- <el-col :span="5">
                <div class="item" v-if="index === 0">医嘱：</div>
              </el-col>-->
              <el-col :span="20">
                <span class="leftTitle" v-if="index === 0">医嘱：</span>
                <span class="leftTitle" v-else></span>
                <span class="detailText">{{item}}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-tabs @tab-click="onSwitch" class="detailTab" v-model="activeName">
      <el-tab-pane label="训练方案" name="训练方案">
        <trainPlanPage
          @resetTreamentstate="loadData"
          v-if="loadTrainPlanCtrl"
          @saveCourseData="saveCourseData"
          :userInfo="userInfo"
          :CanEdit="CanEdit"
        />
      </el-tab-pane>
      <el-tab-pane label="患者病历" name="患者病历">
        <elementButton
          class="addNewButton"
          @click="onClickCaseReocrd"
          size="mini"
          type="primary"
        >创建病历</elementButton>
        <el-table
          :data="caseRecords"
          class="caseRecordsTable"
          @row-click="onClickCaseReocrd"
          :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
          :cell-style="{'padding-left': '5px'}"
        >
          <el-table-column prop="createdTime" align="left" label="病历创建日期" min-width="100"></el-table-column>
          <el-table-column prop="doctor" align="left" label="录入人" min-width="100"></el-table-column>
          <el-table-column
            prop="OD_far_vision_with_glasses"
            align="left"
            label="右眼戴镜远视力"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="OD_near_vision_with_glasses"
            align="left"
            label="右眼戴镜近视力"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="OS_far_vision_with_glasses"
            align="left"
            label="左眼戴镜远视力"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="OS_near_vision_with_glasses"
            align="left"
            label="左眼戴镜近视力"
            min-width="100"
          ></el-table-column>
          <el-table-column prop="checkType" align="left" label="检查方式" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.checkType === 'HOSPITAL_CHECK'">医院检查</span>
              <span v-else>软件自建</span>
            </template>
          </el-table-column>
          <el-table-column prop="checkType" align="left" label width="100">
            <template slot-scope="scope">
              <div>
                <span class="openNewWindow" @click.stop="onClickRemove(scope.row)">
                  <i class="el-icon-delete openInNewStyle" />
                </span>
                <span class="openNewWindow" @click.stop="openInNewWindow(scope.row)">
                  <i class="el-icon-connection openInNewStyle" />
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="训练打卡" name="训练打卡">
        <trainCalendar />
      </el-tab-pane>
      <el-tab-pane label="单次训练" name = "单次训练">
        <MyGames
          :singleGames="singleGames"
          :patientId="patientId"
          @singleGamesChange="singleGamesChange"
        />
      </el-tab-pane>
      <el-tab-pane label="疗程购买历史" name="疗程购买历史">
        <PurchaseHistory
          :purchaseHistorList="patientPurchaseHistory"
          @handleCurrentChange="handleCurrentChange"
          :sourceData="patientPurchaseHistorySource"
        />
      </el-tab-pane>
      <el-tab-pane label="单次购买历史" name="单次购买历史">
        <SinglePurchaseHistory
          :purchaseHistorList="patientSinglePurchaseHistory"
          @handleCurrentChange="handleCurrentChange"
          :sourceData="patientSinglePurchaseHistorySource"
        />
      </el-tab-pane>
      <el-tab-pane label="视力挑战" name="视力挑战">
        <visionChallenge />
      </el-tab-pane>
      <el-tab-pane label="患者系统日志" name="患者日志">
        <patientSystemLog />
      </el-tab-pane>
      <el-tab-pane name="小沐智能">
        <span slot="label" style="line-height: 40px">
          <img class="xiaomuIcon" src="@/assets/xiaomuIcon.png" /> 小沐智能
        </span>
        <xiaomuzhineng :trainingEnabled="userInfo.trainingEnabled" />
      </el-tab-pane>
    </el-tabs>
    <DialogForm
      v-if="centerDialogVisible"
      :formTitle="confirmContent"
      @close="onClickCancel"
      @submitForm="onConfirmEdit"
      confirmButton="确认"
    />
    <!-- <operationDialog
      title="删除病历"
      :Visible="removeCaserecordDialog"
      class="editDialog"
      width="300px"
      @close="onCancelRemoveCaserecord"
      :center="true"
      btnText="确认"
      @confirm="confirmRemoveCaserecord"
    >删除当前病历时，同时会删除该病历的历史版本，请确认是否删除</operationDialog>-->
    <DialogForm
      v-if="removeCaserecordDialog"
      :defaultValue="defaultValue"
      formTitle="请确认是否删除该病例"
      @close="onCancelRemoveCaserecord"
      @submitForm="confirmRemoveCaserecord"
      confirmButton="确认"
    />
  </div>
</template>
<style lang="scss" scoped>
.trainDetailIndex {
  .el-row {
    display: flex;
    // flex-wrap: wrap;
    align-items: flex-start;
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .el-col {
    // align-self: center;
    // line-height: 31px;
    border-radius: 4px;
  }
  .openNewWindow {
    // width: 100%;
    display: inline-block;
    margin-left: 10px;
    .openInNewStyle {
      // width: 12px;
      // height: 12px;
      // margin-left: 5px;
      color: #00c1de;
    }
  }
  .forgetStimulusLevelAlert {
    // padding: 10px 10px 0
  }
}
</style>


<style lang="scss">
@import "@/css/color.scss";

.trainDetailIndex {
  .detailTab {
    background-color: #ffffff;

    .el-tabs__header {
      margin: auto;
      width: 97%;
    }

    .el-tabs__item {
      margin: 10px auto;
    }

    .el-tabs__content {
      min-height: 400px;
      position: unset;
      overflow: unset;
    }
  }
  .trainEyeSuggest {
    // background-color: #e6a23c;
    margin-left: 20px;
    > i {
      color: #e6a23c;
    }
  }
  .configDialog {
    // top: 30px;
    .el-dialog {
      border-radius: 12px;
      margin-top: 5vh !important;
      margin: 0 auto;
    }
    .el-dialog__headerbtn {
      font-size: 23px !important;
    }
    .el-dialog--center .el-dialog__body {
      max-height: 400px;
      overflow-y: scroll;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #00c1de;
    }

    .el-radio__input.is-checked .el-radio__inner {
      border-color: #00c1de;
      background: #00c1de;
    }

    .el-slider__bar {
      background: #00c1de;
    }

    .el-slider__button {
      border-color: #00c1de;
    }

    .dialogConfirmButton {
      border-color: #dcdcdc !important;
      background: linear-gradient(#fdfdfd, #f0f0f0) !important;
      width: 250px;
    }
    .dialogConfirmWithResetButton {
      border-color: #00c1de !important;
      background-color: #00c1de !important;
      width: 250px;
    }
    .eyeDegreeSelect {
      width: 100px;
    }
    .contentCol {
      line-height: 25px;
    }
  }
  .resetPlanDialog {
    .el-dialog {
      border-radius: 12px;

      .el-dialog__headerbtn {
        font-size: 23px;
      }
    }

    .el-dialog--center .el-dialog__body {
      padding-bottom: 0;
    }

    .resetContent {
      text-align: center;

      // margin-top: 30px;
      .resetText {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
        line-height: 27px;
      }

      .levelItem {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(80, 86, 89, 1);
        line-height: 22px;

        .ctrlNumberInput {
          width: 55px;
        }
      }

      .line {
        height: 1px;
        background-color: #e4e8eb;
        width: 90%;
        margin: 16px auto 27px;
      }

      .noticeItem {
        width: 307px;
        margin: 20px auto 10px;

        .el-alert__title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 22px;
        }
      }
    }

    .dialogConfirmButton {
      border-color: #00c1de !important;
      background-color: #00c1de !important;
      width: 307px;
    }
  }

  .cardStyle {
    margin: 0 1%;
    border: 0px;
  }

  .xiaomuIcon {
    width: 20px;
    height: 20px;
    margin-bottom: -5px;
  }
  .smaeVersionConfigRow {
    margin-bottom: 10px;
  }

  .doctorAdviceContent {
    border-color: #00c1de !important;
  }

  .doctorAdviceCol {
    border: 1px solid #e6e6e6;
    margin: 5px;
    padding: 5px;
    min-height: 142px;

    .doctorAdviceText {
      min-width: 300px;
    }

    .doctorAdviceInput {
      width: 370px;
    }

    // .doctorAdviceGroup {
    // }
  }

  .addNewButton {
    margin: 21px 5px;
    width: 110px;
    border: 1px;
    height: 35px;
    margin: 2%;
    font-size: 14px;
    border-radius: 3px;
    float: right;
    padding: 10px;
  }

  .text {
    font-size: 14px;

    .headerText {
      font-size: 18px;
      margin-bottom: 20px;

      > span {
        font-size: 14px;
      }

      .genderStyle {
        // width: 11px;
        height: 17.5px;
        margin-bottom: -2px;
      }
    }
  }

  .item {
    // line-height: 31px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 25px;
  }

  .leftTitle {
    display: inline-block;
    width: 85px;
  }
  .cellItem {
    display: inline-block;
    margin-right: 10px;
  }

  .cellItemInput {
    display: inline-block;
    margin-right: 20px;
    width: 80px;
  }

  .doctorAdvice {
    background-color: #f3f3f3;
    color: #595959;
    width: fit-content;
    padding: 3px 8px;
    border-radius: 8px;
    cursor: pointer;
  }

  .detailText {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 25px;
  }

  .medalContent {
    margin-left: 10px;
  }

  .editIcon {
    display: inline-block;
    margin-left: 50px;
    // padding: 10px;
    font-size: 16px;
    color: #00c1de;
    cursor: pointer;

    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 193, 222, 1);
      line-height: 20px;
    }
  }

  .editButton {
    float: right;
    background-color: #00c1de;
    border-color: #00c1de;
    color: #fff;
  }

  .caseRecordsTable {
    margin: 20px 2%;
    border: 1px;
    width: 97%;

    .checkBoxLabel {
      color: #303133;

      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/patientManagement/patientManagementDetail.vue